import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WindowRef } from '../../../../src/app/utils/window';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'div.dtf-thankyou',
    imports: [SharedTranslateModule,SessionTimeoutComponent,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatIconModule, MatSortModule
    ],
    templateUrl: './thankyou.component.html'
})
export class ThankyouComponent {

    router: Router;
    usUrl: string;
    caUrl: string;
    baseRedirect = '';
    language = '';
    isFrench = false;

   

  constructor(
    router: Router,
    public dtfhomepageService: DTFHomepageService,
    private _window: WindowRef,
    public dialog: MatDialog,
    public translate: TranslateService
  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
  }

  backtohome(){
    this._window.nativeWindow.location.href = this.baseRedirect;
  }

   ngOnInit() {
    this.langInit();
    // const enableGA = sessionStorage.getItem('enableGA') === 'yes';

    // if (enableGA) {
    //   this.triggerGARedirect('/home/thankyou');
    // } 
   }

// triggerGARedirect(returnPath: string): void {
//   this.translate.get('LoginModal.GARedirect').subscribe((data: any) => {
    
//     const returnUrl = this.baseRedirect + returnPath;

//     const gaUrl =
//       this.usUrl +
//       data +
//       'true' +
//       '&page=thankyou' +
//       '&returnUrl=' + encodeURIComponent(returnUrl);

//     this._window.nativeWindow.location.href = gaUrl;
//   });
// }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.baseRedirect = this.usUrl + '/ca/en/home';
    } else if (this.language === 'fr-CA') {
        this.baseRedirect = this.usUrl + '/ca/fr/home';
    } else {
        this.baseRedirect = this.usUrl + '/home';
    }
    this.isFrench = ('fr-CA' === this.language) ? true : false; //checks if language is french or english for Canada
  }

}
